/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';

import {AccountIcon, BasketIcon} from '@salesforce/retail-react-app/app/components/icons';
import Link from '@salesforce/retail-react-app/app/components/link';
import {Box, Button, Center, Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui';

const EmptyCart = ({isRegistered}) => {
  return (
    <Box background="gray.50" data-testid="sf-cart-empty" flex="1" minWidth="100%" width="full">
      <Center>
        <Stack marginBottom="20%" marginTop="20%" spacing={6} width={['343px', '444px']}>
          <Box align="center">
            <BasketIcon boxSize={[8, 10]} />
          </Box>
          <Stack spacing={8}>
            <Stack spacing={2}>
              <Text
                align="center"
                fontSize={['18px', '2xl']}
                fontWeight="bold"
                lineHeight={1}
              >
                <FormattedMessage
                  defaultMessage="Your cart is empty."
                  id="empty_cart.description.empty_cart"
                />
              </Text>

              <Text align="center" color="gray.700" fontSize="md">
                {isRegistered ? (
                  <FormattedMessage
                    defaultMessage="Continue shopping to add items to your cart."
                    id="empty_cart.message.continue_shopping"
                  />
                ) : (
                  <FormattedMessage
                    defaultMessage="Sign in to retrieve your saved items or continue shopping."
                    id="empty_cart.message.sign_in_or_continue_shopping"
                  />
                )}
              </Text>
            </Stack>
            <Stack direction={['column', 'row']} justify="center" spacing={4}>
              <Button
                as={Link}
                color={isRegistered ? 'white' : 'blue.600'}
                href="/"
                variant={isRegistered ? 'solid' : 'outline'}
                width={['343px', '220px']}
              >
                <FormattedMessage
                  defaultMessage="Continue Shopping"
                  id="empty_cart.link.continue_shopping"
                />
              </Button>
              {!isRegistered && (
                <Button
                  as={Link}
                  href="/account"
                  rightIcon={<AccountIcon />}
                  variant="solid"
                  width={['343px', '220px']}
                >
                  <FormattedMessage
                    defaultMessage="Sign In"
                    id="empty_cart.link.sign_in"
                  />
                </Button>
              )}
            </Stack>
          </Stack>
        </Stack>
      </Center>
    </Box>
  );
};

EmptyCart.propTypes = {isRegistered: PropTypes.bool};

export default EmptyCart;
